var _g, _g2, _g3, _g4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoApp = function SvgLogoApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-app_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.14 20.896c0-.573 0-1.146-.003-1.72a67.868 67.868 0 0 0-.021-1.448c-.029-1.052-.09-2.113-.278-3.153-.19-1.055-.5-2.037-.988-2.996a10.074 10.074 0 0 0-4.408-4.406 10.646 10.646 0 0 0-3-.988c-1.04-.187-2.1-.249-3.153-.277a69.387 69.387 0 0 0-1.449-.022c-.573-.003-1.147-.003-1.72-.003l-6.66-.024h-4.98l-6.54.024c-.576 0-1.15 0-1.725.003-.484.003-.968.009-1.452.022-1.054.028-2.118.09-3.16.277-1.058.19-2.043.5-3.004.988a10.102 10.102 0 0 0-4.417 4.406c-.49.959-.8 1.942-.99 2.997-.187 1.04-.25 2.1-.278 3.152a69.37 69.37 0 0 0-.022 1.448c-.003.574-.033 1.286-.033 1.86v11.483l.03 6.588c0 .574 0 1.148.003 1.722.003.483.009.967.022 1.45.028 1.053.09 2.116.278 3.158.19 1.056.5 2.04.99 3a10.092 10.092 0 0 0 4.417 4.412c.961.489 1.946.8 3.005.989 1.042.187 2.105.25 3.16.278.483.013.967.018 1.451.021.575.004 1.15.003 1.724.003H39.12c.573 0 1.147 0 1.72-.003.483-.003.966-.008 1.45-.021 1.052-.029 2.113-.091 3.154-.278 1.056-.19 2.038-.5 2.998-.989a10.08 10.08 0 0 0 4.408-4.412c.489-.96.799-1.944.989-3.002.186-1.04.248-2.103.277-3.156.013-.483.019-.967.021-1.45.004-.574.004-1.148.004-1.722V20.896Z",
    fill: "url(#logo-app_svg__b)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-app_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.07 31.193-2.698.681-1.558-6.167 2.698-.681a4.378 4.378 0 0 0 3.17-5.31 4.378 4.378 0 0 0-5.311-3.17 4.378 4.378 0 0 0-3.17 5.311l.682 2.698-6.167 1.558-.681-2.698a4.378 4.378 0 0 0-5.31-3.17 4.378 4.378 0 0 0-3.17 5.311 4.378 4.378 0 0 0 5.31 3.17l2.699-.682 1.557 6.167-2.698.681a4.378 4.378 0 0 0-3.169 5.31 4.378 4.378 0 0 0 5.311 3.17 4.378 4.378 0 0 0 3.169-5.31l-.681-2.699 6.167-1.557.681 2.698a4.378 4.378 0 0 0 5.31 3.169 4.378 4.378 0 0 0 3.17-5.311 4.378 4.378 0 0 0-5.311-3.169Zm-5.327-9.725a2.786 2.786 0 0 1 2.017-3.38 2.786 2.786 0 0 1 3.38 2.017 2.786 2.786 0 0 1-2.017 3.38l-2.698.68-.681-2.697Zm-11.267 5.715a2.786 2.786 0 0 1-3.38-2.016 2.786 2.786 0 0 1 2.018-3.38 2.786 2.786 0 0 1 3.38 2.017l.68 2.698-2.698.681Zm5.716 11.268a2.786 2.786 0 0 1-2.016 3.38 2.786 2.786 0 0 1-3.38-2.018 2.786 2.786 0 0 1 2.017-3.38l2.698-.68.681 2.698Zm.471-4.63-1.557-6.167 6.167-1.557 1.557 6.167-6.167 1.557Zm12.16 4.31a2.786 2.786 0 0 1-3.38-2.017l-.682-2.698 2.698-.681a2.786 2.786 0 0 1 3.38 2.016 2.786 2.786 0 0 1-2.017 3.38Z",
    fill: "url(#logo-app_svg__d)",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#logo-app_svg__e)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.17,
    filter: "url(#logo-app_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.988 40.015a5.447 5.447 0 0 1 5.445-5.445h5.445v10.89h-5.445a5.447 5.447 0 0 1-5.445-5.445Z",
    fill: "#F2E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.473 24.79a5.447 5.447 0 0 1 5.445-5.445h5.445v10.89h-5.445a5.447 5.447 0 0 1-5.445-5.445Z",
    fill: "#FFEFEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.098 30.185h5.445a5.447 5.447 0 0 1 5.444 5.445 5.447 5.447 0 0 1-5.444 5.444h-5.445v-10.89Z",
    fill: "#FFE1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.528 24.79c0 5.791-4.7 10.492-10.492 10.492-5.792 0-10.493-4.7-10.493-10.493 0-5.792 4.7-10.492 10.492-10.492 5.792 0 10.493 4.7 10.493 10.492Z",
    fill: "#AEE8FF"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-app_svg__g)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-app_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.027 31.024-2.528.639-1.471-5.826 2.528-.639a4.554 4.554 0 0 0 3.296-5.524 4.554 4.554 0 0 0-5.524-3.296 4.554 4.554 0 0 0-3.297 5.524l.639 2.528-5.826 1.471-.639-2.527a4.554 4.554 0 0 0-5.524-3.297 4.554 4.554 0 0 0-3.296 5.524 4.554 4.554 0 0 0 5.524 3.297l2.527-.639 1.472 5.826-2.528.639a4.554 4.554 0 0 0-3.296 5.524 4.554 4.554 0 0 0 5.524 3.296 4.554 4.554 0 0 0 3.296-5.524l-.638-2.528 5.826-1.471.639 2.528a4.554 4.554 0 0 0 5.524 3.296 4.554 4.554 0 0 0 3.296-5.524 4.554 4.554 0 0 0-5.524-3.296Zm-5.113-9.598a2.61 2.61 0 0 1 1.89-3.165 2.61 2.61 0 0 1 3.165 1.889 2.61 2.61 0 0 1-1.889 3.166l-2.528.638-.638-2.527Zm-11.48 5.589a2.61 2.61 0 0 1-3.167-1.89 2.61 2.61 0 0 1 1.89-3.165 2.61 2.61 0 0 1 3.166 1.889l.638 2.528-2.528.638Zm5.588 11.48a2.61 2.61 0 0 1-1.89 3.167 2.61 2.61 0 0 1-3.165-1.89 2.61 2.61 0 0 1 1.889-3.166l2.527-.638.639 2.528Zm.769-4.885-1.472-5.826 5.826-1.472 1.472 5.826-5.826 1.472Zm11.988 4.352a2.61 2.61 0 0 1-3.166-1.889l-.638-2.528 2.527-.638a2.61 2.61 0 0 1 3.166 1.89 2.61 2.61 0 0 1-1.889 3.165Z",
    stroke: "url(#logo-app_svg__i)",
    strokeOpacity: 0.42,
    strokeWidth: 0.352
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-app_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.041 31.081-2.584.653-1.5-5.94 2.584-.652a4.495 4.495 0 0 0 3.254-5.453 4.495 4.495 0 0 0-5.453-3.254 4.495 4.495 0 0 0-3.254 5.453l.653 2.584-5.94 1.5-.653-2.584a4.495 4.495 0 0 0-5.453-3.254 4.495 4.495 0 0 0-3.253 5.453 4.495 4.495 0 0 0 5.453 3.254l2.584-.653 1.5 5.94-2.584.653a4.495 4.495 0 0 0-3.254 5.453 4.495 4.495 0 0 0 5.453 3.253 4.495 4.495 0 0 0 3.254-5.453l-.653-2.584 5.94-1.5.652 2.584a4.495 4.495 0 0 0 5.453 3.254 4.495 4.495 0 0 0 3.254-5.453 4.495 4.495 0 0 0-5.453-3.254Zm-5.184-9.64a2.669 2.669 0 0 1 1.932-3.237 2.669 2.669 0 0 1 3.237 1.931 2.669 2.669 0 0 1-1.932 3.238l-2.584.652-.653-2.584Zm-11.41 5.63a2.669 2.669 0 0 1-3.236-1.93 2.669 2.669 0 0 1 1.931-3.238 2.669 2.669 0 0 1 3.237 1.932l.653 2.584-2.584.653Zm5.632 11.41a2.669 2.669 0 0 1-1.932 3.237 2.669 2.669 0 0 1-3.237-1.931 2.669 2.669 0 0 1 1.931-3.237l2.585-.653.653 2.584Zm.67-4.8-1.501-5.94 5.94-1.5 1.5 5.94-5.94 1.5Zm12.045 4.338a2.669 2.669 0 0 1-3.238-1.931l-.652-2.585 2.584-.653a2.669 2.669 0 0 1 3.237 1.932 2.669 2.669 0 0 1-1.931 3.237Z",
    stroke: "url(#logo-app_svg__k)",
    strokeOpacity: 0.7,
    strokeWidth: 0.234
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-app_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.07 31.195-2.698.681-1.558-6.167 2.698-.681a4.378 4.378 0 0 0 3.17-5.31 4.378 4.378 0 0 0-5.311-3.17 4.378 4.378 0 0 0-3.17 5.31l.682 2.699-6.167 1.558-.681-2.698a4.378 4.378 0 0 0-5.31-3.17 4.378 4.378 0 0 0-3.17 5.311 4.378 4.378 0 0 0 5.31 3.17l2.699-.682 1.557 6.167-2.698.681a4.378 4.378 0 0 0-3.169 5.31 4.378 4.378 0 0 0 5.311 3.17 4.378 4.378 0 0 0 3.169-5.31l-.681-2.699 6.166-1.558.682 2.699a4.378 4.378 0 0 0 5.31 3.169 4.378 4.378 0 0 0 3.17-5.311 4.378 4.378 0 0 0-5.311-3.17Zm-5.327-9.725a2.786 2.786 0 0 1 2.017-3.38 2.786 2.786 0 0 1 3.38 2.017 2.786 2.786 0 0 1-2.017 3.38l-2.698.68-.681-2.697Zm-11.267 5.715a2.786 2.786 0 0 1-3.38-2.016 2.786 2.786 0 0 1 2.018-3.38 2.786 2.786 0 0 1 3.38 2.017l.68 2.698-2.698.681Zm5.716 11.268a2.786 2.786 0 0 1-2.016 3.379 2.786 2.786 0 0 1-3.38-2.017 2.786 2.786 0 0 1 2.017-3.38l2.698-.68.681 2.697Zm.471-4.63-1.557-6.167 6.167-1.557 1.557 6.167-6.167 1.557Zm12.16 4.31a2.786 2.786 0 0 1-3.38-2.017l-.682-2.698 2.698-.681a2.786 2.786 0 0 1 3.38 2.016 2.786 2.786 0 0 1-2.017 3.38Z",
    fill: "url(#logo-app_svg__m)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo-app_svg__a",
    x: 4.688,
    y: 5.508,
    width: 50.625,
    height: 50.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.82
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.586
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_895_216894"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_895_216894",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.234
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_895_216894"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_innerShadow_895_216894",
    result: "effect3_innerShadow_895_216894"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-app_svg__c",
    x: 14.664,
    y: 16.061,
    width: 29.555,
    height: 29.554,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.527,
    dy: 0.879
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_895_216894"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_895_216894",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-app_svg__e",
    x: 7.617,
    y: 7.441,
    width: 44.766,
    height: 44.874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.428,
    result: "effect1_foregroundBlur_895_216894"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-app_svg__f",
    x: 8.586,
    y: 8.41,
    width: 42.828,
    height: 42.936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.943,
    result: "effect1_foregroundBlur_895_216894"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-app_svg__h",
    x: 14.723,
    y: 14.716,
    width: 30.492,
    height: 30.491,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.674,
    result: "effect1_foregroundBlur_895_216894"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-app_svg__j",
    x: 13.434,
    y: 13.427,
    width: 33.07,
    height: 33.069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.377,
    result: "effect1_foregroundBlur_895_216894"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-app_svg__l",
    x: 16.422,
    y: 16.298,
    width: 27.094,
    height: 27.327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.117
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_895_216894"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.117
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_895_216894",
    result: "effect2_innerShadow_895_216894"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-app_svg__b",
    x1: 30,
    y1: 5.859,
    x2: 30,
    y2: 54.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-app_svg__d",
    x1: 33.428,
    y1: 24.698,
    x2: 13.583,
    y2: 36.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-app_svg__i",
    x1: 38.438,
    y1: 15.471,
    x2: 28.154,
    y2: 22.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-app_svg__k",
    x1: 40.077,
    y1: 14.373,
    x2: 18.464,
    y2: 31.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-app_svg__m",
    x1: 41.629,
    y1: 27.235,
    x2: 17.773,
    y2: 33.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B4B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-app_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-14.175 84.42 -40.47)",
    d: "M0 0h28.894v28.894H0z"
  })))));
};

export default SvgLogoApp;